<template>
  <el-dialog :title="title" :visible="dialogFormVisible" :before-close="handleClose" width="60%">
    <div class="middle_cont">
      <div class="topimg">
        <img :src="'images/' + logoUrl" alt="">
      </div>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item>
          <b class="wordtitle">企业简介</b>
          <p>{{form.description}}</p>
        </el-form-item>
        <el-form-item>
          <b class="wordtitle">主要业绩</b>
          <p>{{form.mainPerformance}}</p>
        </el-form-item>
        <el-form-item>
          <b class="wordtitle">地址</b>
          <p>{{form.address}}</p>
        </el-form-item>
        <el-form-item>
          <b class="wordtitle">联系电话</b>
          <p>{{form.linkTel}}</p>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addUpActive, imgUpload } from "common/js/api";
export default {
  components: {},

  props: ["dialogVisible", "title", "detailData"],

  data() {
    return {
      dialogFormVisible: false,
      form: {
        description: "",
        mainPerformance: "",
        address: "",
        linkTel: ""
        
      },
      logoUrl: ''
    };
  },

  mounted() {},

  methods: {
    handleClose() {
      this.dialogFormVisible = false;
      this.$emit("closeDialog");
    }
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue;
    },
    detailData: {
      handler(val) {
        this.logoUrl = val.logoUrl;
        this.form.address = val.address;
        this.form.linkTel = val.linkTel;
        this.form.mainPerformance = val.mainPerformance;
        this.form.description = val.description;
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.middle_cont {
  padding: 0 160px;
}
.wordtitle {
  width: 103px;
  height: 32px;
  font-size: 24px;
  font-family: MicrosoftYaHeiSemibold;
  color: rgba(15, 24, 36, 1);
  line-height: 32px;
  font-style: normal;
}
.size {
  width: 397px;
  height: 18px;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: rgba(108, 120, 133, 1);
  line-height: 21px;
}
.topimg {
  height: 120px;
  text-align: center;
}
.middle_cont >>> .el-form-item {
  margin-bottom: 20px !important;
}
.middle_cont >>> .el-upload--picture-card {
  width: 240px !important;
  height: 100px !important;
}
.middle_cont >>> .el-upload--picture-card span {
  position: relative;
  top: -20%;
  transform: translateY(50%);
  color: #6c7885;
}
.middle_cont >>> .el-upload--picture-card span .el-icon-plus {
  font-size: 12px !important;
  padding-right: 10px !important;
}
.middle_cont >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 240px !important;
}
</style>
